import PropTypes from 'prop-types';

function IFDeliInactive({ className, width }) {
    return (
        <svg width={width} viewBox="0 0 31 31" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
            <g clipPath="url(#clip0_386_11294)">
                <path
                    d="M3.11998 18.3162C3.11998 18.3162 2.66736 18.5802 2.7428 19.4779C2.84841 20.7717 3.87434 20.1267 5.54904 20.1757L27.2974 18.2898C27.2974 18.2898 29.602 18.2559 29.5605 17.3016C29.519 16.3473 28.3875 16.5472 28.3875 16.5472L3.11998 18.3162Z"
                    fill="#F8F2ED"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M4.06665 20.3037C4.10437 20.7337 4.23638 23.1062 5.39056 23.9435C6.54474 24.7808 9.37739 24.1095 13.8244 23.7247C18.2714 23.34 25.8942 22.9704 26.8825 22.7026C27.3696 22.5793 27.8042 22.3027 28.122 21.9135C28.4399 21.5243 28.6242 21.0432 28.6477 20.5413C28.661 19.7581 28.5927 18.9756 28.444 18.2065L4.06665 20.3037Z"
                    fill="#F8F2ED"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M3.0747 15.9888C3.0747 15.9888 2.03368 19.0478 3.68951 18.9346C7.89133 18.6442 13.6207 17.6484 15.8009 17.8219C17.981 17.9954 18.3883 20.2849 19.7424 21.1638C21.304 22.1784 22.1677 20.5226 23.0616 17.3919C23.4577 16.1321 26.2149 17.0864 28.3686 16.5508C30.0772 16.1397 30.3639 14.9591 29.3757 13.9596C28.6213 13.2052 24.1706 12.6432 15.3558 13.4353C6.54101 14.2274 3.0747 15.9888 3.0747 15.9888Z"
                    fill="#F8F2ED"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M3.52369 13.922C3.52369 13.922 1.78865 13.922 1.36243 15.227C0.872094 16.7131 2.89002 17.4901 4.75708 17.3279C5.80764 17.2845 6.82576 16.9516 7.69911 16.3661C8.20348 15.9934 8.63015 15.5257 8.95513 14.9894C8.95513 14.9894 9.46433 16.7433 12.4478 16.5924C14.032 16.517 15.1221 15.9361 15.8727 14.3972C16.8232 15.8305 18.2716 16.3284 20.0519 15.9927C21.6096 15.7023 22.7299 13.888 22.7299 13.888C23.6895 14.5781 24.7914 15.0446 25.9548 15.2534C27.7087 15.525 31.0581 15.6117 30.6281 13.3486C30.0585 11.8399 27.6634 12.0247 27.6634 12.0247L3.52369 13.922Z"
                    fill="#F8F2ED"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M3.52374 13.922C3.48602 12.6961 2.90893 9.35053 6.08482 8.50187C9.2607 7.65321 17.8982 7.26848 20.761 6.93656C23.6238 6.60464 26.2075 7.29111 27.0147 9.12045C27.8219 10.9498 27.6635 12.0248 27.6635 12.0248L3.52374 13.922Z"
                    fill="#F8F2ED"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10.377 7.82289C10.377 7.82289 8.04978 9.84836 9.82631 11.7418C10.1809 10.267 10.6863 8.56594 13.055 7.56641C11.5086 7.77009 10.377 7.82289 10.377 7.82289Z"
                    fill="#F8F2ED"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14.6393 7.45336C14.6393 7.45336 12.3121 9.48261 14.0848 11.3761C14.4394 9.90128 14.9448 8.23413 17.3135 7.22705L14.6393 7.45336Z"
                    fill="#F8F2ED"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18.6299 7.13665C18.6299 7.13665 16.4536 9.1244 18.2339 11.0179C18.5884 9.54308 18.9015 7.92873 21.2513 6.9292C19.7049 7.04613 18.6299 7.13665 18.6299 7.13665Z"
                    fill="#F8F2ED"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
            <defs>
                <clipPath id="clip0_386_11294">
                    <rect width="30" height="30" fill="white" transform="translate(0.976562 0.600586)" />
                </clipPath>
            </defs>
        </svg>
    );
}

export default IFDeliInactive;

IFDeliInactive.propTypes = {
    className: PropTypes.string,
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

IFDeliInactive.defaultProps = {
    className: null,
    width: 28,
};
